/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import withValidarRecuperar from 'HOC/withValidarRecuperar';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import imgBreadCrum from 'assets/img/mex/accidentesPersonales/imgbreadcrumAP.png';
import BreadcrumcomponentLogo from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import Page from 'components/Page';
import { ambienteAplicacion } from 'constants/urls';
import { URLS_PHP_7 } from 'constants/urls_v2';
import { useNavbarContext } from 'contexts/NavbarContext';
import useCustomRouter from 'hooks/useCustomRouter';
import useLoading from 'hooks/useLoading';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import useParametrosPago from 'redux/hooks/useParametrosPago';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import Loading from 'wrappers/Loading';
import { PRODUCTOS } from '../../utils/constants';
import { MarineInland } from './constantes/general';
import ResumenInland from './formas/ResumenInland';
import './styles.scss';

const API = ApiKeyFetch.instance();

const MarineInlandResumen = ({ params: { idCotizacion }, addWarningToast, dataUsuario, estadoGeneral }) => {
  const { setProductoActivo } = useNavbarContext();
  const [loading, setLoading] = useState(false);

  const [datosTarifacion, setDatosTarifacion] = useState(null);
  const history = useCustomRouter();
  const { loading: recalculando, setLoading: recalcular } = useLoading();
  const [permiteEmitir, setPermiteEmitir] = useState(true);
  const [cotizacion, setCotizacion] = useState(null);
  const [prod, setProducto] = useState(null);
  const methods = useForm();
  const { fetchParametros, handleContinue, ...stateParametrosPago } = useParametrosPago();
  const [bloquearEmision, setBloquearEmision] = useState(false);
  const [bloquearEmisionMsg, setBloquearEmisionMsg] = useState('');

  useEffect(() => {
    if (stateParametrosPago?.error?.message) {
      addWarningToast(stateParametrosPago?.error?.message, { autoDismiss: false });
    }
  }, [stateParametrosPago.error]);

  const getResumen = async () => {
    setProductoActivo(PRODUCTOS.MARINE_INLAND);
    setLoading(true);
    const DataResumen = {
      cotDatos: { ambiente: ambienteAplicacion, cotCodigo: idCotizacion },
    };
    const resResumen = await API.post(URLS_PHP_7.cotizacion.resumenCotizacion, DataResumen);
    if (resResumen.transaccion) {
      setDatosTarifacion(resResumen?.cotConsulta?.totGenerales[0]);
      setCotizacion(resResumen?.cotConsulta);
      setProducto(resResumen?.cotConsulta.prodDatos);
      setBloquearEmision(!resResumen?.cotConsulta?.totGenerales[0]?.permitirEmitir ?? false);
      setBloquearEmisionMsg(resResumen?.cotConsulta?.totGenerales[0]?.msgError ?? '');
    }
    setLoading(false);
  };

  useEffect(() => {
    getResumen();
    getParametrosPagos();
  }, []);

  const getParametrosPagos = () => {
    fetchParametros(MarineInland.codProducto, idCotizacion);
  };

  useEffect(() => {
    if (datosTarifacion) {
      if (!datosTarifacion?.permitirEmitir) {
        addWarningToast(datosTarifacion.msgError);
      }
      setPermiteEmitir(datosTarifacion?.permitirEmitir);
    }
  }, [datosTarifacion]);

  const tarifar = async ({ idPlazo, formaPago, labelPlazo }) => {
    if (estadoGeneral?.polizaPagada?.validacion) {
      addWarningToast(estadoGeneral?.polizaPagada?.msgError);
    } else {
      const descuentoRecargo = methods.getValues('descuentoRecargo');
      const vigencia = methods.getValues('vigencia');
      const mesesVigencia = methods.getValues('mesesVigencia');

      recalcular(true);
      const DataTarifacion = {
        ambiente: ambienteAplicacion,
        cotCodigo: idCotizacion,
        idPlazo,
        formaPago,
        labelPlazo,
        descuentoRecargo: descuentoRecargo,
        vigencia: vigencia,
        mesesVigencia: mesesVigencia,
      };

      console.log('TARIFACION DATA: ', JSON.stringify(DataTarifacion));

      const res = await API.post(URLS_PHP_7.cotizacion.tarifacionCotizacion, DataTarifacion);
      console.log('RES TARIFACION: ', res);
      if (res.transaccion) {
        setDatosTarifacion(res.datosTarifacion);

        setCotizacion({
          ...cotizacion,
          carUrlPdf: res.datosTarifacion.urlPdfCotizacion,
        });

        recalcular(false);
      } else {
        return addWarningToast('Ha ocurrido un problema al realizar la tarifación');
      }
    }
  };

  const onContinuar = async () => {
    if (estadoGeneral?.polizaPagada?.validacion) {
      onRedireccionar(estadoGeneral?.pasosRedireccionamiento);
    } else {
      const Data = {
        datosCotizador: {
          ambiente: ambienteAplicacion,
          prodCodigo: PRODUCTOS.MARINE_INLAND,
          cotPasoCodigo: 'crearPoliza',
          cotCodigo: idCotizacion,
        },
      };

      setLoading(true);
      const res = await API.post(URLS_PHP_7.emision.datosEmision, Data);

      if (res.transaccion && res.catalogo.idPoliza) {
        const route = res?.catalogo?.pasosRedireccionamiento.find((e) => e.codigo === 'resumen');

        history.replace(route.goTo);
        history.push(route.goTo);
      }

      setLoading(false);
    }
  };
  const onRedireccionar = (pasos) => {
    const route = pasos.find((e) => e.codigo === 'resumen');
    history.replace(route.goTo);
    history.push(route.goTo);
  };

  const onClickAtras = () => {
    history.push(`${MarineInland.urls.ingresoEquipos}/${idCotizacion}?back=true`);
  };
  return (
    <React.Fragment>
      <Loading loading={loading}>
        {cotizacion && datosTarifacion && prod && (
          <FormProvider {...methods}>
            <div className="cr-content">
              <Page>
                {/*<ModalBloqueoEmision bloquear={bloquearEmision} msgError={bloquearEmisionMsg}/>*/}
                <BreadcrumcomponentLogo {...PASOS_BREADCRUMBS[MarineInland.codProducto].breadCrumb} />
                <BreadCrumbPasosV2 {...PASOS_BREADCRUMBS[MarineInland.codProducto].breadCrumbPasos[(1, 2, 3)]} />

                <ResumenInland
                  cotizacion={cotizacion}
                  prod={prod}
                  datosTarifacion={datosTarifacion}
                  idCotizacion={idCotizacion}
                  imgBreadCrum={imgBreadCrum}
                  dataUsuario={dataUsuario}
                  setDatosTarifacion={setDatosTarifacion}
                  recalculando={recalculando}
                  recalcular={recalcular}
                  tarifar={tarifar}
                  bloquearEmision={bloquearEmision}
                />

                <div className="row justify-content-center my-5">
                  <div className="col-11 col-sm-5 col-md-3 col-xl-2">
                    <button className="btn btn-atras-api" onClick={onClickAtras}>
                      Atrás
                    </button>
                  </div>
                  <div className="col-11 col-sm-5  col-md-3 col-xl-2">
                    <button
                      className="btn btn-siguiente-api"
                      onClick={handleContinue(methods.handleSubmit(onContinuar))}
                      type="submit"
                      disabled={recalculando || !permiteEmitir || bloquearEmision}
                    >
                      Siguiente
                    </button>
                  </div>
                </div>
              </Page>
            </div>
          </FormProvider>
        )}
      </Loading>
    </React.Fragment>
  );
};

export default withValidarRecuperar(MarineInlandResumen, PRODUCTOS.MARINE_INLAND);
